import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import classnames from "classnames";
// javascript plugin that creates nice dropzones for files
import Dropzone from "dropzone";
// reactstrap components
import {
    UncontrolledAlert,
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Label,
    Container,
    Row,
    Col,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { createInvoice } from "api/einvoiceApiCall";


Dropzone.autoDiscover = false;

function AddEinvoice() {
    const [sidenavOpen, setSidenavOpen] = useState(true);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [discountError, setDiscountError] = useState('');
    const [formData, setFormData] = useState({
        customer_name: '',
        customer_address: '',
        customer_email: '',
        customer_phone: '',
        invoice_date: '',
        discount: '',
        subtotal: '',
    });
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        // Calculate subtotal based on products
        const productTotal = selectedProducts.reduce((total, product) => {
            return total + (parseFloat(product.price) || 0) * (parseInt(product.quantity, 10) || 1);
        }, 0);

        const discountAmount = parseFloat(formData.discount) || 0;

        if (discountAmount > productTotal) {
            setDiscountError('Discount cannot exceed the total price');
        } else {
            setDiscountError('');
        }

        const subtotal = Math.max(productTotal - discountAmount, 0);

        setFormData(prevData => ({
            ...prevData,
            subtotal: subtotal.toFixed(2)
        }));
    }, [selectedProducts, formData.discount]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleProductChange = (index, e) => {
        const { name, value } = e.target;
        const updatedProducts = [...selectedProducts];
        updatedProducts[index][name] = value;
        setSelectedProducts(updatedProducts);
    };

    const handleAddProduct = () => {
        setSelectedProducts([...selectedProducts, { product_name: '', price: '', quantity: '' }]);
    };

    const handleRemoveProduct = (index) => {
        const updatedProducts = selectedProducts.filter((_, i) => i !== index);
        setSelectedProducts(updatedProducts);
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const updatedFormData = {
            customer_name: formData.customer_name,
            customer_address: formData.customer_address,
            customer_email: formData.customer_email,
            customer_phone: formData.customer_phone,
            invoice_date: formData.invoice_date,
            products: selectedProducts,
            discount: formData.discount,
            subtotal: formData.subtotal,
        };

        const [errorInvoicesCall, successInvoiceCall] = await createInvoice(updatedFormData);

        if (errorInvoicesCall || !successInvoiceCall) {
            setError(errorInvoicesCall.message || "An unknown error occurred.");
            setShowErrorAlert(true);
        } else {
            setShowSuccessAlert(true);
            setTimeout(() => {
                navigate('/admin/einvoice');
            }, 2000);
        }
    };

    return (
        <>
            <SimpleHeader name="Add Invoice" />
            <Container className="mt--6" fluid>
                <Row>
                    <Col lg="12">
                        <div className="card-wrapper">
                            <Card>
                                <CardHeader>
                                    <h3 className="mb-0">Add Invoice</h3>
                                    {showSuccessAlert && (
                                        <UncontrolledAlert color="success">
                                            <strong>Success!</strong> Invoice creation successful!
                                        </UncontrolledAlert>
                                    )}

                                    {showErrorAlert && (
                                        <UncontrolledAlert color="danger">
                                            <strong>Error!</strong> Invoice creation failed—please try again!
                                        </UncontrolledAlert>
                                    )}
                                </CardHeader>
                                <CardBody>
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Customer name"
                                                        type="text"
                                                        name="customer_name"
                                                        value={formData.customer_name}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Customer Address"
                                                        type="text"
                                                        name="customer_address"
                                                        value={formData.customer_address}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Customer Email"
                                                        type="email"
                                                        name="customer_email"
                                                        value={formData.customer_email}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Customer phone"
                                                        type="phone"
                                                        name="customer_phone"
                                                        value={formData.customer_phone}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>


                                        {selectedProducts.map((product, index) => (
                                            <Row key={index}>
                                                <Col md="5">
                                                    <FormGroup>
                                                        <Input
                                                            placeholder="Product name"
                                                            type="text"
                                                            name="product_name"
                                                            value={product.product_name}
                                                            onChange={(e) => handleProductChange(index, e)}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="2">
                                                    <FormGroup>
                                                        <Input
                                                            placeholder="Quantity"
                                                            type="number"
                                                            name="quantity"
                                                            value={product.quantity}
                                                            onChange={(e) => handleProductChange(index, e)}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <Input
                                                            placeholder="Price"
                                                            type="text"
                                                            name="price"
                                                            value={product.price}
                                                            onChange={(e) => handleProductChange(index, e)}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="2">
                                                    <Button color="danger" onClick={() => handleRemoveProduct(index)}>
                                                        Remove
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ))}

                                        {/* <Button color="secondary" onClick={handleAddProduct}>
                                            Add Product
                                        </Button> */}

                                        <Button className="btn-icon mb-4" color="info" onClick={handleAddProduct}>
                                            <span className="btn-inner--icon mr-1">
                                                <i className="ni ni-bag-17" />
                                            </span>
                                            <span className="btn-inner--text">Add Product</span>
                                        </Button>

                                        <Row>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Date"
                                                        type="date"
                                                        name="invoice_date"
                                                        value={formData.invoice_date}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Discount"
                                                        type="text"
                                                        name="discount"
                                                        value={formData.discount}
                                                        onChange={handleInputChange}
                                                        invalid={!!discountError}
                                                        required
                                                    />
                                                    {discountError && <div className="text-danger">{discountError}</div>}
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Subtotal"
                                                        type="text"
                                                        name="subtotal"
                                                        value={formData.subtotal}
                                                        readOnly
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Button className="btn-icon" color="primary" type="submit" disabled={!!discountError}>
                                            <span className="btn-inner--icon mr-1">
                                                <i className="ni ni-bag-17" />
                                            </span>
                                            <span className="btn-inner--text">Submit</span>
                                        </Button>
                                    </Form>
                                </CardBody>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}


export default AddEinvoice;
